import React, { useRef     } from "react";
import Header from "../components/global/Header";
import LeftNavbar from "../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';

export default function Unauthorized() {
    const scrollRef = useRef(null);
    const { t } = useTranslation();
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content error-page" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap">
             <div className="error-404">
                <div className="icon-404"></div>
                <span>Unauthorized</span>
             </div>
          </div>
        </section>
      </div>
     </div>
  )
}
